
import './App.css';

import {  BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Index from './components/Index';
import AboutUs from './components/AboutUs';

import Service from './components/Service';
import CoursesH from './components/CoursesH';
import Projects from './components/Projects';
import ContactUs from './components/ContactUs';
import EnquiryForm from './page/EnquireForm';
import Cv from './buttons/Cv';
import OrderManager from './admin/OrderManager';
import CategoryManager from './admin/CategoryManager';
import UserManager from './admin/UserManager';
import Dashboard from './admin/DashBoard';
import AdminPannel from './admin/AdminPannel';
import ProductManager from './admin/ProductManager';
import Chess from './game/Chess';
import Ludo from './game/Ludo';
import UploadPost from './admin/UploadPost';
import JavaCompiler from './compiler/JavaCompiler';
import PostDetail from './page/PostDetail';
import GeometricAnimation from './annime/GeometricAnimation ';
import Gear from './components/Gear';
import BudgetCalculate from './components/BudgetCalculate';
// import ThreeScene from './page/Three';


function App() {
  return (
    <>
     <Router basename="/">
      <Routes>
      
       
        <Route path="/" element={<Index/>} />
        <Route path="/aboutus" element={<AboutUs/>} />
        <Route path="/service" element={<Service/>} />
        <Route path="/coursesinfo" element={<CoursesH/>} />
        <Route path="/project" element={<Projects/>} />
        <Route path="/contact" element={<ContactUs/>} />
        <Route path="/ef" element={<EnquiryForm/>} />
        <Route path="/cv" element={<Cv/>} />
        <Route path="/admin" element={<AdminPannel/>} />
        <Route path="/ad" element={<ProductManager/>} />
        <Route path="/admin" element={<AdminPannel/>} />
        <Route path="/chess" element={<Chess/>} />
        <Route path="/ludo" element={<Ludo/>} />
        <Route path="/upload-post" element={<UploadPost/>} />
        <Route path="/Dashboard" element={<Dashboard/>} />
        <Route path="/om" element={<OrderManager/>} />
        <Route path="/cm" element={<CategoryManager/>} />
        <Route path="/users" element={<UserManager/>} />
        <Route path="/javaCompiler" element={<JavaCompiler/>} />
        <Route path="/gear" element={<Gear/>} />
<Route path="/react" element={<GeometricAnimation/>} />
      <Route path="/post" element={<PostDetail/>} /> 
       <Route path="/AI" element={<BudgetCalculate/>} /> 
           </Routes>


    

    </Router>
    </>
  );
}

export default App;
